import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { IconButton } from '../../../components'
import {
  Breadcrumbs,
  PageContent,
  PageHeader
} from '../../../layout/components'
import { OrdersReportForm } from './components/Form'
import { OrdersReportProvider } from './context/ordersReport.context'

export const OrdersReport = () => {
  const navigation = useNavigate()
  return (
    <div>
      <PageHeader>
        <div
          style={{
            fontSize: 22,
            fontWeight: 800,
            marginBottom: '.5rem',
            height: 40,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <IconButton
            onClick={() => navigation('/reports')}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <MdKeyboardArrowLeft
              size={24}
              color="#565656"
              style={{ background: '' }}
            />
          </IconButton>
          <div style={{ marginLeft: '1rem', fontSize: 22, fontWeight: 800 }}>
            Relatório de Pedidos
          </div>
        </div>
        <Breadcrumbs
          links={[{ url: 'reports', name: 'Relatórios' }]}
          span="Relatório de Pedidos"
        ></Breadcrumbs>
      </PageHeader>
      <PageContent>
        <OrdersReportForm />
      </PageContent>
    </div>
  )
}

export const OrdersReportPage = () => (
  <OrdersReportProvider>
    <OrdersReport />
  </OrdersReportProvider>
)

export default OrdersReport
